import { ObjectSchema, object, string, number, mixed, array } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { CeuUnit } from './../../models/ceu-unit';
import { CommunicationType, communicationTypes } from './../../models/fu-unit';
import './../custom-method';
import { FcuUnit } from '../../models/fcu-unit';
import { fcuUnitLocationLenLimit } from '../fcu-unit/fcu-unit-validator';

yup.setLocale(locale);

function customFcuUnitValidator(): ObjectSchema<FcuUnit> {
    return object({
        id: string().uuid().required().strict(),
        vesselId: string().uuid().required().strict(),
        index: number().required().strict(),
        location: string().strict().max(fcuUnitLocationLenLimit).nullable().defined(),
    })
        .strict()
        .noUnknown();
}

export function ceuValidator(): ObjectSchema<CeuUnit> {
    return object({
        id: string().uuid().strict(),
        index: number().nonNullable().required().strict(),
        fcuId: string().uuid().strict(),
        vesselId: string().uuid().strict(),
        Ports: array().required().nonNullable().strict(),
        commType: mixed<CommunicationType>().oneOf(Object.values(communicationTypes)).required().strict(),
        lineAIp: string().isIp().nullable().strict().required(),
        lineBIp: string().isIp().nullable().strict().required(),
        location: string().max(fcuUnitLocationLenLimit).notRequired().strict(),
        FcuUnit: customFcuUnitValidator().optional().default(undefined),
    })
        .strict()
        .noUnknown() as unknown as ObjectSchema<CeuUnit>;
}
